import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormControlStyles = makeStyles()((theme: Theme) => ({
	helperText: {
		margin: theme.spacing(0.5, 1.5, 0, 0),
		lineHeight: 1.2,
		minHeight: theme.spacing(2),
	},
	removeField: {
		minHeight: "unset",
	},
}));
